import { useTranslation } from 'react-i18next';

interface PageErrorProps {
  title?: string;
  message?: string;
  onRetry?: () => void;
}

export function PageError({
  title,
  message,
  onRetry,
}: PageErrorProps) {
  const { t } = useTranslation();
  const resolvedTitle = title ?? t('common.error');
  const resolvedMessage = message ?? t('dashboard.error');

  return (
    <div className="p-6 bg-gradient-to-r from-red-50 to-red-100/50 border-l-4 border-red-500 rounded-lg">
      <div className="flex items-start gap-3">
        <span className="text-xl shrink-0">⚠️</span>
        <div className="flex-1">
          <h3 className="text-base font-semibold text-red-800">{resolvedTitle}</h3>
          <p className="text-sm text-red-700 mt-1">{resolvedMessage}</p>
          {onRetry && (
            <button
              onClick={onRetry}
              className="mt-3 px-4 py-1.5 text-sm font-medium text-red-700 bg-white border border-red-300 rounded-lg hover:bg-red-50 transition"
            >
              {t('common.retry', 'Réessayer')}
            </button>
          )}
        </div>
      </div>
    </div>
  );
}
